<template>
  <custom-tooltip
    :right="'right-0'"
    :left="'left-initial'"
    :top="'top-120-p'"
    :other-class="'rounded px-3 py-2'"
    :tooltip-position="'bottom'"
    style="left: auto !important"
  >
    <slot />
    <template #tooltip-content>
      <label class="block mb-1 text-xs font-medium text-gray-100 flex">
        <ion-icon
          v-if="minimum_eight"
          name="checkmark-circle"
          class="h-4 w-4 text-green-600 mr-1"
        ></ion-icon>
        <ion-icon
          v-else
          name="close-circle"
          class="h-4 w-4 text-red-600 mr-1"
        ></ion-icon>
        8 Characters
      </label>
      <label class="block mb-1 text-xs font-medium text-gray-100 flex">
        <ion-icon
          v-if="has_upper_case"
          name="checkmark-circle"
          class="h-4 w-4 text-green-600 mr-1"
        ></ion-icon>
        <ion-icon
          v-else
          name="close-circle"
          class="h-4 w-4 text-red-600 mr-1"
        ></ion-icon>
        Contains Uppercase
      </label>
      <label class="block mb-1 text-xs font-medium text-gray-100 flex">
        <ion-icon
          v-if="has_lower_case"
          name="checkmark-circle"
          class="h-4 w-4 text-green-600 mr-1"
        ></ion-icon>
        <ion-icon
          v-else
          name="close-circle"
          class="h-4 w-4 text-red-600 mr-1"
        ></ion-icon>
        Contains Lowercase
      </label>
      <label class="block mb-1 text-xs font-medium text-gray-100 flex">
        <ion-icon
          v-if="has_number"
          name="checkmark-circle"
          class="h-4 w-4 text-green-600 mr-1"
        ></ion-icon>
        <ion-icon
          v-else
          name="close-circle"
          class="h-4 w-4 text-red-600 mr-1"
        ></ion-icon>
        Contains Number
      </label>
    </template>
  </custom-tooltip>
</template>

<script>
import CustomTooltip from "./CustomTooltip.vue"

export default {
  name: "PasswordValidator",

  components: {
    CustomTooltip,
  },

  emits: ["password-verified"],

  data() {
    return {
      passwordValidated: false,
      minimum_eight: false,
      has_upper_case: false,
      has_lower_case: false,
      has_number: false,
    }
  },

  methods: {
    password_check(password) {
      if (/.{8,}/.test(password)) {
        this.minimum_eight = true
      } else {
        this.minimum_eight = false
      }
      if (/[A-Z]+/.test(password)) {
        this.has_upper_case = true
      } else {
        this.has_upper_case = false
      }
      if (/[a-z]+/.test(password)) {
        this.has_lower_case = true
      } else {
        this.has_lower_case = false
      }
      if (/[0-9]+/.test(password)) {
        this.has_number = true
      } else {
        this.has_number = false
      }
      if (this.minimum_eight && this.has_upper_case && this.has_lower_case && this.has_number) {
        this.passwordValidated = true
        this.$emit("password-verified", true)
      } else {
        this.passwordValidated = false
        this.$emit("password-verified", false)
      }
    },
  },
}
</script>

<style scoped>
ion-icon {
  visibility: visible !important;
}
</style>

<style>
.left-initial {
  left: initial !important;
}
</style>
